import { useQuery } from "@tanstack/react-query";
import { api } from "../../../../singleton/axios";

export interface AftermarketTrade {
  symbol: string;
  price: number;
  tradeSize: number;
  timestamp: number;
}

export function useCompanyAftermarketTrade(ticker: string, enabled = true) {
  return useQuery<AftermarketTrade[], Error>({
    queryKey: ["companyAftermarketTrade", ticker],
    queryFn: async () => {
      const { data } = await api.get<AftermarketTrade[]>(
        "/company-aftermarket-trade",
        {
          params: { ticker },
        }
      );
      return data;
    },
    // Callers gate on the market being closed — during trading hours the
    // response is discarded anyway, so fetching it is pure waste.
    enabled: !!ticker && enabled,
    refetchOnWindowFocus: false,
    refetchInterval: 30 * 1000,
    staleTime: 15 * 1000,
    gcTime: 5 * 60 * 1000,
  });
}
